module.exports = __webpack_public_path__ + "img/promo.c749cd83.jpg";